import axios from "axios";

// Resolve the API base URL.
// 1. If REACT_APP_BACKEND_URL is set at build time, use it verbatim with /api appended.
// 2. Otherwise, default to "/api/proxy.php?path=" which works through the PHP proxy
//    on Aruba Windows hosting WITHOUT requiring IIS URL Rewrite.
const RAW = process.env.REACT_APP_BACKEND_URL;
const USE_PROXY = !RAW || RAW.trim() === "";

const buildUrl = (path) => {
    // path comes in like "/auth/login"
    if (USE_PROXY) {
        // /api/proxy.php?path=/auth/login (encoded)
        return `/api/proxy.php?path=${encodeURIComponent(path)}`;
    }
    return `${RAW}/api${path}`;
};

const api = axios.create({
    timeout: 30000,
});

// Inject Bearer + rewrite URL through our proxy if needed
api.interceptors.request.use((config) => {
    const token = localStorage.getItem("ns_token");
    if (token) {
        config.headers = config.headers || {};
        config.headers.Authorization = `Bearer ${token}`;
    }
    // Rewrite the URL through the proxy (or absolute backend) and merge query params
    if (config.url) {
        const [pathOnly, qs] = config.url.split("?");
        const finalUrl = buildUrl(pathOnly);
        if (qs) {
            const sep = finalUrl.includes("?") ? "&" : "?";
            config.url = `${finalUrl}${sep}${qs}`;
        } else {
            config.url = finalUrl;
        }
    }
    return config;
});

// Helper to coerce FastAPI's 422 array `detail` to a string
export const formatApiError = (err) => {
    const d = err?.response?.data?.detail;
    if (d == null) return err?.message || "Network error. Please try again.";
    if (typeof d === "string") return d;
    if (Array.isArray(d))
        return d
            .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
            .filter(Boolean)
            .join(" · ");
    if (d && typeof d.msg === "string") return d.msg;
    return String(d);
};

export default api;
